import { DecryptData } from "../utils/encryptDecrypt";
// ----------------------------------------------------------------------

const account = {
  displayName: DecryptData(localStorage.getItem('username')) || 'Admin User',
  email: 'superadmin@extramarks.com',
  password: 'extramarks@admin',
  photoURL: 'https://cdn.pixabay.com/photo/2018/08/28/12/41/avatar-3637425_960_720.png',
  role: DecryptData(localStorage.getItem('role')) || 'Super Admin'
};

export default account;
